<template>
  <div v-if="userdata && userdata.records.length" class="page">
    <div class="mach-width flex data-content-user">
      <div v-for="(u,indx) in userdata.records" :key="indx" class="flex-center data-content-user-item cursor" :class="indx%3==2?'space-none':''" @click="searchUser(u)">
        <div class="img">
          <el-image class=" mach-height mach-width" :src="u.avatar">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </div>
        <div class="flex-column flex-1">
          <p class="font-size-16 font-color-264480 text-line-1 tit" v-html="u.htmlName" />
          <p class="font-size-12 font-color-999 text-line-1 des">发布 {{ u.collectionNumber }} 馆藏</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="user-empty flex flex-center mach-width">
    <p class=" font-size-14 font-color-666">暂无内容</p>
  </div>
</template>

<script>
export default {
  props: {
    userdata: {
      type: Object,
      default: null
    }
  },
  data(){
      return{
        // loading: true
      }
     
    },
  methods: {
    searchUser(v) {
      this.$emit('searchUser', v)
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>

  .data-content-user {
    flex-wrap: wrap;
    margin-top: 30px;
  }
  .data-content-user-item {
    width: 280px;
    height: 80px;
    padding: 0 20px;
    border: 1px solid rgba(26, 59, 128, 0.1);
    margin-bottom:36px ;
    margin-right: 40px ;
  }

  .data-content-user-item .img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 8px;
  }

  .space-none {
    margin: 0;
  }

  .data-content-user-item .img div {
    width: 50px;
    height: 50px;
    background-image: url('https://libraryplus.bjadks.com/img/pic-default-40.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .tit {
    height: 24px;
    line-height: 24px;
  }

  .des {
    height: 20px;
  }

  .user-empty{
    height: 400px;
  }

</style>
